import { useEffect, useState } from "react";

const useHideOnScroll = (hideThreshold, containerId = null) => {
  const [ isVisible, setIsVisible ] = useState(false);

  useEffect(() => {
    const container = document.getElementById(containerId);

    const listenToScroll = () => {
      const heightToShowFrom = hideThreshold;
      const containerScroll = container?.scrollTop || document.documentElement.scrollTop;
    
      containerScroll > heightToShowFrom
        ? !isVisible && setIsVisible(true)
        : setIsVisible(false);
    };

    (container || window).addEventListener('scroll', listenToScroll);

    return () => (container || window).removeEventListener('scroll', listenToScroll);
  }, []);

  return isVisible;
};

export default useHideOnScroll;
